<template>
	<div>
		<ed-modal 
			:title="formData.id == 0 ? 'Novo Email' : 'Editar Email'" 
			:modal="showFormEdit" 
			:loadingSave="config.loading.save"
			:onSave="salvar"
			width="95%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<ed-form :data="formData" :config="config" :response="response" :itens="exameItems">
					<div slot="form-footer"></div>
				</ed-form>
			</div>
		</ed-modal>
	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdForm from 'common/form';
	import EdModal from 'common/modal';
	import FormItems  from './_form/email-cadastrar';

  	export default {
  		name:"exame-editar",
  		components: {EdForm,EdModal},
		mixins:[Rest],
		props:{
            parent:{
                type: Object,
                default: null
			},
			showForm:{
				type: Boolean,
                default: false
			}
        },
		watch: {
			'parent.formData.id'(){
			},
			showForm(){
				this.showFormEdit = !this.showFormEdit;
				this.init();
			},
		},
  		data () {
		   	return {
				config:{
					tipo:[240,32],
					tipo_exclude:[33,34,35,36,37,196],
					hidden:{
						padrao:true
					},
					click:{
					},
					loading:{
						save:false,
						content:false,
					},
					list:{
					}
				},
		   		formData:{
		   			id:0,
		   			nome:null,
		   			usuario:null,
		   			email:null,
		   			servidor_smtp:null,
		   			autenticacao:1,
		   			conexao_seg:'tls',
					senha:null,
					porta:0,
					tempo_espera:0,
					n_msg_pct:50,
					t_esp_pct:600,
					updated_at:null,
					tipo:[]
		   		},
				response:{},
				exameItems:[],
				showFormEdit:false,
			}
		},

		mounted() {
			this.exameItems = FormItems;
		},

		methods: {

			init(){

				this.response = {};
				
				var tipo = [];

				for (let i = 0; i < this.parent.formData.tipo.length; i++) {
					const element = this.parent.formData.tipo[i];
					tipo.push(element.id);
					
				}
				this.formData = {
					id:this.parent.formData.id,
		   			nome:this.parent.formData.nome,
		   			usuario:this.parent.formData.usuario,
		   			email:this.parent.formData.email,
		   			servidor_smtp:this.parent.formData.servidor_smtp,
		   			autenticacao:this.parent.formData.autenticacao,
					conexao_seg:this.parent.formData.conexao_seg,
					porta:this.parent.formData.porta,
		   			senha:null,
					tempo_espera:this.parent.formData.tempo_espera,
					n_msg_pct:this.parent.formData.n_msg_pct,
					t_esp_pct:this.parent.formData.t_esp_pct,
					updated_at:this.parent.formData.updated_at,
					tipo:tipo
				};
			},


			salvar(){

				this.response = {};
				this.config.loading.save = true;

				this.post('conta-email/editar',this.formData).then((result)=>{

					result = result[0];

					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Registro salvo com sucesso!');
						this.showFormEdit = !this.showFormEdit;
						
						if(this.parent && this.parent.getContaEmail)
							this.parent.getContaEmail();
					}	

				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// editar.vue?8732919a